export function convertFiltersToQueryParams(filters) {
  let queryParams = {};
  let filteredMembers = [];

  for (let filter of filters) {
    if (filter.category.key === 'dates') {
      const dates = filter.value.key

      queryParams.updateTimeFrom = dates[0]
      if (dates.length > 1) {
        queryParams.updateTimeTo = dates[1]
      }
    }

    if (filter.category.key === 'members') {
      filteredMembers.push(filter.value.key)
    }
  }

  if (filteredMembers.length > 0) {
    queryParams.usersUpdatingFiles = filteredMembers
  }

  return queryParams
}
